import * as React from "react";
import { useNavigate } from "react-router";
import {
  Button,
  makeStyles,
  shorthands,
  Toast,
  Toaster,
  ToastTitle,
  useId,
  useToastController,
} from "@fluentui/react-components";
import { ArrowLeft20Regular } from "@fluentui/react-icons";
import { KennzahlenRiskForm } from "../components/RisikenTabelleDataGrid";

const useStyles = makeStyles({
  root: {
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    "@media (min-width: 768px)": {
      paddingTop: "24px",
      paddingBottom: "24px",
      paddingLeft: "24px",
      paddingRight: "24px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    columnGap: "12px",
    marginBottom: "16px",
  },
  legacyBadge: {
    display: "inline-flex",
    alignItems: "center",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "8px",
    paddingRight: "8px",
    backgroundColor: "rgba(247,168,35,0.18)",
    color: "#7a4c00",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    ...shorthands.borderRadius("999px"),
  },
});

const RisikoKennzahlenLegacyPage = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const toasterId = useId("kennzahlen-legacy-toaster");
  const { dispatchToast } = useToastController(toasterId);

  return (
    <div className={styles.root}>
      <Toaster toasterId={toasterId} position="top-end" />
      <div className={styles.header}>
        <Button
          appearance="subtle"
          icon={<ArrowLeft20Regular />}
          onClick={() => navigate("/risks/new")}
        >
          Zurück
        </Button>
        <h2 style={{ margin: 0 }}>Kennzahlen erfassen — Alte Ansicht</h2>
        <span className={styles.legacyBadge}>Legacy</span>
      </div>
      <KennzahlenRiskForm
        onCancel={() => navigate("/risks/new")}
        onSave={(data) => {
          console.log("Saved Kennzahlen (Legacy):", data);
          dispatchToast(
            <Toast>
              <ToastTitle>Kennzahlen gespeichert (Legacy)</ToastTitle>
            </Toast>,
            { intent: "success" }
          );
          window.setTimeout(() => navigate("/risks"), 600);
        }}
      />
    </div>
  );
};

export default RisikoKennzahlenLegacyPage;
